/* Reiter im Spielerpanel, je Status.
 *
 * Reine Funktion, kein DOM. Die Rechteprüfung (can/isVisible) bleibt in
 * PlayerPanel.vue — hier steht nur, welche Reiter es gibt und in welcher
 * Reihenfolge. `area` ist der Bereich der Rechtematrix (domain/permissions.js).
 *
 * Player Info gibt es für JEDEN Status.
 *
 * Transfer Info (Regel seit 2026-10-04, Entscheidung Bastian): Der Reiter erscheint,
 * wenn der Status "transferred" ist ODER der Spieler mindestens einen Eintrag in
 * player_transfers hat (Option hasTransfers). Kein Eintrag und nicht transferred: kein
 * Reiter. Das gilt auch für "released" — ein freigegebener Spieler mit Historie
 * behält den Reiter (für Gäste liefert die Datenbank bei released ohnehin keine
 * Einträge, siehe player_visible_to_public).
 *
 * Reihenfolge (seit 2026-10-04, Entscheidung Bastian): Player Info steht in JEDEM Status an
 * erster Stelle, auch bei "transferred", und ist damit der Reiter, mit dem die Akte
 * aufgeht. Transfer Info (wenn es ihn gibt) steht direkt dahinter. (Vorher stand
 * Transfer Info bei "transferred" vorn.) Die Liste "Released" ist davon unabhängig
 * (isOutOfSquad in domain/status.js, usePlayers.js).
 */

const PASS = { key: 'pass', label: 'tabs.playerInfo', area: 'players' };
/* Bereich "players", nicht "contracts": Der Reiter ist für alle Rollen sichtbar, weil
   auch Gäste die Transferhistorie sehen sollen (Entscheidung Bastian, 2026-10-04).
   Die kaufmännischen Vertragsfelder darin (Art, Ende, Ablöse, Sell-on) bleiben
   weiter hinter can('contracts','read') (SectorTransfer.vue). */
const TRANSFER = { key: 'transfer', label: 'tabs.transferInfo', area: 'players' };

/**
 * Zeigt das Panel den Reiter Transfer Info? Eine Stelle für die Regel: tabsForStatus
 * (unten) und der Knopf "Add transfer" in Player Info (SectorPass.vue) fragen dasselbe.
 */
export function hasTransferTab(status, hasTransfers = false) {
  return status === 'transferred' || hasTransfers === true;
}

/**
 * @param {string} status
 * @param {{ hasTransfers?: boolean }} [options] hasTransfers: gibt es Einträge in player_transfers?
 */
export function tabsForStatus(status, { hasTransfers = false } = {}) {
  return [
    PASS,
    ...(hasTransferTab(status, hasTransfers) ? [TRANSFER] : []),
    { key: 'documents', label: 'tabs.documents', area: 'documents' },
    { key: 'travel', label: 'tabs.travel', area: 'travel' },
    { key: 'material', label: 'tabs.material', area: 'media' },
    /* Eigener Bereich: X11 Motion ist nur für admin, board und data sichtbar, bis X11 angebunden
       ist (Entscheidung Bastian, 2026-10-04). Für staff und guest verschwindet der Reiter ganz. */
    { key: 'x11', label: 'tabs.x11', area: 'x11' },
  ];
}
